import { Alert, Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { usePackageFeatures } from '../hooks/usePackageFeatures';

type FeatureReadOnlyBannerProps = {
  feature: string;
};

export const FeatureReadOnlyBanner: React.FC<FeatureReadOnlyBannerProps> = ({ feature }) => {
  const { t } = useTranslation();
  const { user, isAnonymous } = useAuth();
  const { isLocked } = usePackageFeatures(isAnonymous || !user ? null : user.publicId);

  if (!isLocked(feature)) return null;

  return (
    <Alert
      severity="warning"
      className="mx-4 mt-4 md:mx-6"
      action={
        <Button component={Link} to={`/subscription?feature=${feature}`} size="small">
          {t('packageFeatures.upgrade')}
        </Button>
      }
    >
      {t(`packageFeatures.readOnly.${feature}`)}
    </Alert>
  );
};
